export default function(){
(function($) {
    var colorPickerCanvas;

//     $( document ).ready(function(){
//         colorPickerCanvas= document.querySelector("canvas").getContext("2d");
//         colorPickerCanvas.height=200;
//         colorPickerCanvas.width=200;
//
//         var img = new Image();
//         img.src = 'color_img.png';
//         $(img).load(function(){
//             colorPickerCanvas.drawImage(img,0,0,200,200);
//         });
//     });
//
//     $("test").click(function(event){
//         var x = event.pageX - $(this).offset().left;
//         var y = event.pageY - $(this).offset().top;
//
//         var imgData = colorPickerCanvas.getImageData(x, y, 1, 1).data;
//         var R = imgData[0];
//         var G = imgData[1];
//         var B = imgData[2];
// console.log(R+","+G+","+B);
//         $("div").css("background","rgb("+R+","+G+","+B+")");
//     });
    // $(document).ready(function() {
    //     $('.creepy_image--modal .creepyImage ').on('click', function (event) {
    //         console.log("test");
    //         if (!$(this).parent('div').siblings("div.modalContainer").is($("div.modalContainer--show")[0])) {
    //             $(this).parent('div').siblings("div.modalContainer").toggleClass("modalContainer--show");
    //         } else {
    //             $(this).parent('div').siblings("div.modalContainer").toggleClass("modalContainer--show");
    //         }
    //
    //     });
    // });
    // $(document).ready(function(){
    //     $('a.creepyButton__modal').removeAttr("href");
    //     $('a.creepyButton__modal').on('click', function(event){
    //         if(!$(this).closest('div').find("div.modalContainer").is($("div.modalContainer--show")[0])) {
    //             $("div.modalContainer--show:first").removeClass("modalContainer--show");
    //             $(this).closest('div').find("div.modalContainer").toggleClass("modalContainer--show");
    //         }
    //         else {
    //             $(this).closest('div').find("div.modalContainer").toggleClass("modalContainer--show");
    //         }
    //     });
    //     $(document).click(function(event) {
    //         //if you click on anything except the modal itself or the "open modal" link, close the modal
    //         if (!$(event.target).closest(".modalContent,.creepyButton__modal,.creepyImage").length) {
    //             $("body").find(".modalContainer").removeClass("modalContainer--show");
    //             $("body").css({"overflow-y" : "auto"});
    //             $(".response-box-rychla-poptavka").hide();
    //             $(".creepy__paragraph").show();
    //         }
    //     });
    //
    //     $(".modalContent--close").click(function (event) {
    //         $("body").find(".modalContainer").removeClass("modalContainer--show");
    //         $("body").css({"overflow-y" : "auto"});
    //         $(".response-box-rychla-poptavka").hide();
    //         $(".creepy__paragraph").show();
    //     });
    // });
})(jQuery);
}